import { apiFetch } from "@/lib/api";

export const WIRELESS_ASSIGNMENTS_QUERY_KEY = ["manufacturing", "wireless-assignments", "workspace"] as const;

export interface WirelessAssignmentsOrganizationRow {
  organization_id: number;
  name: string;
  domain: string | null;
  client_fs_account_id: number | null;
  client_label: string | null;
  group_id: number | null;
  group_name: string | null;
}

export interface WirelessAssignmentsGroupRow {
  group_id: number;
  group_name: string;
  organization_id: number;
}

export interface WirelessAssignmentsClientRow {
  fs_account_id: number;
  fs_account_name: string | null;
  mv_client_name: string | null;
  mv_end_user_name: string | null;
}

export interface WirelessAssignmentsUserContactRow {
  first_name: string | null;
  last_name: string | null;
  contact_email: string | null;
  email_list: string | null;
  organization_name: string | null;
}

export interface WirelessAssignmentsWorkspaceResponse {
  read_source: "live_rds" | "supabase_mirror";
  organizations: WirelessAssignmentsOrganizationRow[];
  groups: WirelessAssignmentsGroupRow[];
  clients: WirelessAssignmentsClientRow[];
  user_contacts: WirelessAssignmentsUserContactRow[];
}

export function fetchWirelessAssignmentsWorkspace(): Promise<WirelessAssignmentsWorkspaceResponse> {
  return apiFetch<WirelessAssignmentsWorkspaceResponse>("/api/manufacturing/wireless-assignments/workspace");
}

export function patchWirelessAssignmentsOrganizationClient(
  organizationId: number,
  fsAccountId: number | null,
): Promise<{ ok: true; organizations: WirelessAssignmentsOrganizationRow[]; clients: WirelessAssignmentsClientRow[] }> {
  return apiFetch(`/api/manufacturing/wireless-assignments/organizations/${String(organizationId)}/client`, {
    method: "PATCH",
    body: { fsAccountId },
  });
}

export function formatWirelessAssignmentsClientOptionLabel(client: WirelessAssignmentsClientRow): string {
  const account = client.fs_account_name?.trim() ?? "";
  const endUser = client.mv_end_user_name?.trim() ?? "";
  return account || endUser || `Client ${String(client.fs_account_id)}`;
}
